module.exports = __webpack_public_path__ + "static/media/courrier_accompagnement_proposition_GPI_GO.af23f3ea.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/common/form/courrier_accompagnement_proposition_GPI_GO.pdf
// module id = 312
// module chunks = 40